import { Button } from '@cian/ui-kit';
import * as React from 'react';

import styles from './index.css';
import { MODERATION_STATUS_TYPES, TModerationStatus } from '../../types';
import { Phone } from '../phone/Phone';

interface IState {
  isPhoneVisible: boolean;
}

export interface IMainContactsProps {
  displayPhone?: boolean;
  moderationStatus?: TModerationStatus;
  phone?: string;
  trackShowPhoneClick(): void;
}

export class MainContacts extends React.Component<IMainContactsProps, IState> {
  public state = {
    isPhoneVisible: false,
  };

  public render() {
    const { displayPhone, moderationStatus, phone } = this.props;
    if (moderationStatus !== MODERATION_STATUS_TYPES.Published || !displayPhone || !phone) {
      return null;
    }

    return (
      <div className={styles['container']}>
        <div className={styles['title']}>Как узнать больше о посёлке?</div>
        <div className={styles['description']}>
          <div>Наиболее свежая информация находится у застройщика.</div>
          <div>Позвоните ему, чтобы узнать больше.</div>
        </div>
        {this.state.isPhoneVisible ? (
          <Phone phone={phone} style={styles['phone']} />
        ) : (
          <Button onClick={this.handlePhoneCollapseButtonChange} size="XS">
            Показать телефон
          </Button>
        )}
      </div>
    );
  }

  private handlePhoneCollapseButtonChange = () => {
    this.setState({
      isPhoneVisible: true,
    });
    this.props.trackShowPhoneClick();
  };
}
